import React from 'react';
import { SelectButton } from '../../app/components';
import './styles.css';

const TypeStep = ({ fields, onSelectType }) => (
  <div className="step-content types-step">
    <h2>Tegund</h2>
    <p>
      Við flokkum eignir niður í 4 tegundir.<br />
      Veldu þá tegund sem þú telur þína eign tilheyra.
    </p>
    <div className="types">
      <SelectButton
        content={<div><span className="icon-house-icon" /><p>Hús</p></div>}
        selected={fields.type.value === 'house'}
        disabled={false}
        onClick={e => onSelectType(e, fields, 'house')}
      />
      <SelectButton
        content={<div><span className="icon-apt-icon" /><p>Íbúð</p></div>}
        selected={fields.type.value === 'apartment'}
        disabled={false}
        onClick={e => onSelectType(e, fields, 'apartment')}
      />
      <SelectButton
        content={<div><span className="icon-room-icon" /><p>Herbergi</p></div>}
        selected={fields.type.value === 'room'}
        disabled={false}
        onClick={e => onSelectType(e, fields, 'room')}
      />
      <SelectButton
        content={<div><span className="icon-commercial-icon" /><p>Atvinnu-<br />húsnæði</p></div>}
        selected={fields.type.value === 'commercial'}
        disabled={false}
        onClick={e => onSelectType(e, fields, 'commercial')}
      />
    </div>
  </div>
);

TypeStep.propTypes = {
  fields: React.PropTypes.object.isRequired,
  onSelectType: React.PropTypes.func.isRequired,
};

export default TypeStep;



// WEBPACK FOOTER //
// ./src/browser/steps/TypeStep/TypeStep.js